module.exports = function getResource(label, vars = []) {
    let resources = {
        paypalAccount: 'PayPal Account',
        removePaypal: 'Remove PayPal'
    };

    return resources[label];
};
